<script>
import { mapState, mapActions } from 'vuex'

export default {
   data() {
      return {
         form: {
            tahun: new Date(this.$store.state.DashboardSkm.tahun, 0, 1),
         },
         isRefreshing: false,
      }
   },
   computed: {
      ...mapState({
         statistik: state => state.DashboardSkm.statistik,
         tahun: state => state.DashboardSkm.tahun,
         skin: state => state.appConfig.layout.skin,
      }),
      isDark() {
         return this.skin === 'dark'
      },
      getThisYear() {
         return this.tahun
      },
      triwulanCards() {
         return [
            {
               key: 'tw1', title: 'Triwulan I', icon: 'AwardIcon', color: 'primary',
            },
            {
               key: 'tw2', title: 'Triwulan II', icon: 'AwardIcon', color: 'success',
            },
            {
               key: 'tw3', title: 'Triwulan III', icon: 'AwardIcon', color: 'warning',
            },
            {
               key: 'tw4', title: 'Triwulan IV', icon: 'AwardIcon', color: 'info',
            },
         ]
      },
   },
   watch: {
      'form.tahun': function onYearChanged(newYear) {
         if (newYear) this.refreshStatistics(newYear)
      },
   },
   mounted() {
      this.refreshStatistics(this.form.tahun)
   },
   methods: {
      async refreshStatistics(year) {
         if (this.isRefreshing) return

         this.isRefreshing = true
         try {
            await this.getStatistik(year)
            this.triggerRefresh()
         } finally {
            this.isRefreshing = false
         }
      },
      formatIndeks(tw) {
         const source = tw || {}
         return `${source.indeks || '0,00'} (${source.grade || '-'})`
      },
      formatResponden(tw) {
         return Number((tw || {}).responden || 0).toLocaleString('id-ID')
      },
      ...mapActions({
         getStatistik: 'DashboardSkm/getStatistik',
         triggerRefresh: 'DashboardSkm/triggerRefresh',
      }),
   },
}
</script>

<template>
   <b-row>
      <b-col cols="12">
         <b-card
            no-body
            class="statistics-wrapper overflow-hidden"
            :class="{ 'statistics-wrapper-dark': isDark }"
         >
            <div class="statistics-heading p-2 d-flex flex-wrap align-items-center justify-content-between">
               <div class="d-flex align-items-center">
                  <div class="logo-wrapper mr-1 mr-md-2">
                     <b-img
                        :src="require('@/assets/images/logo/survey-dpmptsp.png')"
                        alt="Logo SKM"
                        height="54"
                        class="img-fluid"
                     />
                  </div>
                  <div>
                     <h3 class="text-white mb-25">
                        SKM
                     </h3>
                     <p class="text-white mb-0 statistics-subtitle">
                        Survei Kepuasan Masyarakat Tahun {{ getThisYear }}
                     </p>
                  </div>
               </div>
               <div class="skm-toolbar d-flex align-items-end mt-1 mt-md-0">
                  <b-form-group class="mb-0 mr-1">
                     <datepicker
                        id="dashboard-skm-tahun"
                        v-model="form.tahun"
                        :minimum-view="'year'"
                        :maximum-view="'year'"
                        format="yyyy"
                        input-class="datepicker-here form-control"
                        :disabled="isRefreshing"
                     />
                  </b-form-group>
                  <b-button
                     variant="light"
                     class="d-flex align-items-center"
                     :disabled="isRefreshing"
                     title="Muat ulang data"
                     @click="refreshStatistics(form.tahun)"
                  >
                     <b-spinner v-if="isRefreshing" small class="mr-50" />
                     <feather-icon v-else icon="RefreshCwIcon" class="mr-50" />
                     Refresh
                  </b-button>
               </div>
            </div>

            <b-card-body class="p-1 p-md-2">
               <h5 class="section-title mb-50">
                  IKM DPMPTSP
               </h5>
               <b-row>
                  <b-col
                     v-for="stat in triwulanCards"
                     :key="`skm-${stat.key}`"
                     cols="12"
                     sm="6"
                     lg="3"
                     class="mb-1"
                  >
                     <b-card
                        no-body
                        class="statistic-card h-100"
                        :class="{ 'statistic-card-dark': isDark }"
                     >
                        <b-card-body class="d-flex align-items-start p-1-5">
                           <div :class="['statistic-icon', `icon-${stat.color}`]">
                              <feather-icon :icon="stat.icon" size="20" />
                           </div>
                           <div class="ml-1 flex-grow-1">
                              <div class="statistic-value">
                                 {{ formatIndeks(statistik.skm[stat.key]) }}
                              </div>
                              <h5 class="statistic-title mb-25">
                                 {{ stat.title }} {{ getThisYear }}
                              </h5>
                              <small class="text-muted">
                                 Responden : {{ formatResponden(statistik.skm[stat.key]) }}
                              </small>
                           </div>
                        </b-card-body>
                     </b-card>
                  </b-col>
               </b-row>

               <h5 class="section-title mb-50 mt-1">
                  IKM Semua Instansi (MPP)
               </h5>
               <b-row>
                  <b-col
                     v-for="stat in triwulanCards"
                     :key="`skm-mpp-${stat.key}`"
                     cols="12"
                     sm="6"
                     lg="3"
                     class="mb-1"
                  >
                     <b-card
                        no-body
                        class="statistic-card h-100"
                        :class="{ 'statistic-card-dark': isDark }"
                     >
                        <b-card-body class="d-flex align-items-start p-1-5">
                           <div :class="['statistic-icon', `icon-${stat.color}`]">
                              <feather-icon :icon="stat.icon" size="20" />
                           </div>
                           <div class="ml-1 flex-grow-1">
                              <div class="statistic-value">
                                 {{ formatIndeks(statistik.skmMpp[stat.key]) }}
                              </div>
                              <h5 class="statistic-title mb-25">
                                 {{ stat.title }} {{ getThisYear }}
                              </h5>
                              <small class="text-muted">
                                 Responden : {{ formatResponden(statistik.skmMpp[stat.key]) }}
                              </small>
                           </div>
                        </b-card-body>
                     </b-card>
                  </b-col>
               </b-row>
            </b-card-body>
         </b-card>
      </b-col>
   </b-row>
</template>

<style scoped>
.statistics-wrapper {
   border: 0;
   border-radius: 12px;
   background-color: #ffffff;
   box-shadow: 0 4px 24px rgba(34, 41, 47, 0.08);
}

.statistics-wrapper-dark {
   background-color: #283046;
   box-shadow: 0 4px 24px rgba(0, 0, 0, 0.25);
}

.statistics-heading {
   background: linear-gradient(135deg, #0f6cbd 0%, #00cfe8 100%);
}

.logo-wrapper {
   width: 64px;
   height: 64px;
   display: flex;
   align-items: center;
   justify-content: center;
   padding: 5px;
   border-radius: 12px;
   background: rgba(255, 255, 255, 0.18);
}

.statistics-subtitle {
   opacity: 0.8;
   font-size: 0.85rem;
}

.skm-toolbar {
   min-width: 180px;
}

.section-title {
   font-weight: 600;
}

.statistic-card {
   border: 1px solid #ebe9f1;
   border-radius: 10px;
   transition: transform 0.2s ease, box-shadow 0.2s ease;
   margin-bottom: 0rem;
}

.statistic-card:hover {
   transform: translateY(-3px);
   box-shadow: 0 6px 16px rgba(34, 41, 47, 0.1);
}

.statistic-card-dark {
   border-color: #3b4253;
   background-color: #283046;
}

.statistic-card-dark:hover {
   box-shadow: 0 6px 16px rgba(0, 0, 0, 0.25);
}

.p-1-5 {
   padding: 1rem !important;
}

.statistic-icon {
   width: 38px;
   height: 38px;
   border-radius: 10px;
   display: flex;
   align-items: center;
   justify-content: center;
   flex-shrink: 0;
}

.icon-primary {
   background: rgba(0, 207, 232, 0.12);
   color: #00cfe8;
}

.icon-success {
   background: rgba(40, 199, 111, 0.12);
   color: #28c76f;
}

.icon-warning {
   background: rgba(255, 159, 67, 0.12);
   color: #ff9f43;
}

.icon-info {
   background: rgba(115, 103, 240, 0.12);
   color: #7367f0;
}

.icon-danger {
   background: rgba(234, 84, 85, 0.12);
   color: #ea5455;
}

.icon-secondary {
   background: rgba(115, 103, 240, 0.12);
   color: #7367f0;
}

.statistic-value {
   color: #5e5873;
   font-size: 1.35rem;
   font-weight: 700;
   line-height: 1.1;
}

.statistic-card-dark .statistic-value {
   color: #f6f6f6;
}

.statistic-title {
   color: #5e5873;
   font-size: 0.9rem;
   font-weight: 600;
   line-height: 1.2;
}

.statistic-card-dark .statistic-title {
   color: #f6f6f6;
}

.statistic-card small {
   font-size: 0.72rem;
   line-height: 1.15;
}

.statistic-card-dark .text-muted {
   color: #b4b7bd !important;
}

@media (max-width: 575.98px) {
   .statistics-heading {
      padding: 1rem !important;
   }

   .p-1-5 {
      padding: 0.75rem !important;
   }
}
</style>
